module.exports = __webpack_public_path__ + "img/ES0019.d1e282cf.png";